import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useIntl } from 'react-intl';
//Components
import InputDate from 'Components/InputDate';
import { Select, Button, Input } from '@gpstrackit/react-controls';
import { getLastRecorsOptions, getMinDateLimitBehaviour } from 'Core/data/Helpers';
import { getWarningTypes } from 'Utils/data';

//Styles
import './filters.scss';

const Filters = (props) => {
    const { startDate, endDate, setStartDate, setEndDate, setBeforeRangeDate, beforeRangeDate, setLast, last, type, setType, onlyLast, setEsn, esn, warningType, setWarningValue, warningValue, disabled, single, dateType, handleOrderType, lastOptionsLimit, hideTypeSelection, notApply, noClass, maxDate, minDate, extraButtonFilter } = props;
    const { messages } = useIntl();

    const onChangeStartEndDate = ({ start, end }) => {
        const newStart = start && new Date(start);
        const newEnd = end && new Date(end);
        // Set New Date Range
        setStartDate(newStart);
        setEndDate(newEnd);
        if (start && end) {
            const newDateRange = {
                start,
                end,
            };
            setBeforeRangeDate(newDateRange)
            props?.onChangeStartEndDate && props.onChangeStartEndDate({ start, end })
        }
    }

    const onCloseSelectDate = () => {
        const { start, end } = beforeRangeDate;
        if (start && end && !endDate) {
            setStartDate(start);
            setEndDate(end);
            props?.onCloseSelectDate && props.onCloseSelectDate()
        }
    }

    const onChange = (value) => {
        const { start, end } = value;
        onChangeStartEndDate({
            start,
            end
        })

        props?.onChange && props.onChange(value)
    };

    const handleApply = () => {
        props?.onChangeFilters && props.onChangeFilters();
    }

    return (
        <div className={noClass ? "" : `container-filters-vidfleet`}>

            {
                warningType &&
                <div style={{ 
                    /* width: "100%", */ 
                    flex: "1 1 110px",
                    minWidth: 110,
                    maxWidth: 200,  
                    marginRight: 5 
                }}
                >
                    <Select
                        id="warning-type"
                        options={getWarningTypes()}
                        textField="label"
                        valueField="id"
                        value={warningValue}
                        onChange={setWarningValue}
                        isClearable
                        placeholder={messages['vidfleet_warning_type']}
                    />
                </div>
            }
            {
                setEsn && !single &&
                <div style={{ 
                    /* width: "100%", */ 
                    flex: "1 1 110px",
                    maxWidth: 200, 
                    minWidth: 110, 
                    marginRight: 5 
                    }}>
                    <Input
                        value={esn}
                        onChange={(value) => setEsn(value)}
                        placeholder={messages['vidfleet_search_by_esn']}
                    />
                </div>
            }
            {
                !onlyLast && type && !hideTypeSelection &&
                <div className='filters-type' style={{ display: 'flex' }}>
                    <FormControlLabel
                        value={true}
                        control={<Radio onClick={() => setType('last')} checked={type === 'last'} color="primary" />}
                        label={messages['vidfleet_last']}
                        labelPlacement="start"
                    />
                    <FormControlLabel
                        value="start"
                        control={<Radio onClick={() => setType('range')} checked={type === 'range'} color="primary" />}
                        label={messages['vidfleet_range']}
                        labelPlacement="start"
                    />
                </div>
            }
            {
                type === 'last' || onlyLast
                    ?
                    <div
                    style={{
                        /* width: "100%", */
                        flex: "0 0 auto",
                        maxWidth: 110,
                        minWidth: 90
                    }}
                        >
                        <Select
                            id="last"
                            textField="name"
                            valueField="id"
                            value={last}
                            options={getLastRecorsOptions(lastOptionsLimit) || []}
                            onChange={(value) => setLast(value)}
                            placeholder={messages['select']}
                        />
                    </div>
                    :
                    <div style={{ 
                        /* width: "100%", */ 
                        /* flex: "1 1 160px", */
                        minWidth: 160,
                        maxWidth: 220, 
                    }}
                    >
                        <InputDate
                            id="input-date-range"
                            type="range"
                            onChange={onChange}
                            onClose={onCloseSelectDate}
                            value={startDate}
                            valueEnd={endDate}
                            maxDate={maxDate || new Date()}
                            minDate={minDate || getMinDateLimitBehaviour()}
                        />
                    </div>
            }
            {
                dateType &&
                <div 
                style={{ 
                    /* width: "100%", */ 
                    flex: "1 1 90px",
                    minWidth: 90,
                    maxWidth: 150, 

                    marginRight: 5, 
                    marginLeft: 5 
                }}
                >
                    <Select
                        id="unit-time"
                        placeholder="Select"
                        options={[{ id: "unitTime", label: messages['common_unit_time'] }, { id: "serverTime", label: messages['common_server_time'] }]}
                        value={dateType || { id: "unitTime", label: messages['common_unit_time'] }}
                        textField="label"
                        valueField="id"
                        onChange={handleOrderType}
                    />
                </div>
            }
            {
                !notApply &&
                <div 
                style={{ 
                    /* width: "100%", */ 
                    /* flex: "1 1 90px", */
                    minWidth: 90,
                    maxWidth: 150,

                    marginLeft: 5,
                    display: "flex",
                    justifyContent: "flex-end"
                }}
                >
                    <Button disabled={disabled} onClick={handleApply} className="btn-dark-blue">
                        {messages['vidfleet_apply']}
                    </Button>
                </div>
            }
            {
                extraButtonFilter && extraButtonFilter()
            }
        </div>
    )
}

export default Filters;